<template>
    <div>
        <v-toolbar color="#ECEFF1">
            <v-spacer></v-spacer>

            <v-toolbar-items>
                <v-btn text @click="getCSV" class="mr-5">
                    <v-icon>mdi-export</v-icon>
                </v-btn>
                <v-text-field
                    v-model="search"
                    append-icon="search"
                    style="width: 250px"
                    class="pr-5 pt-3"
                    hide-details
                >
                </v-text-field>
            </v-toolbar-items>
        </v-toolbar>
        <div style="overflow-x: auto; width: 100%;">
        <v-data-table
            :headers="this.parentObject.tabHeader"
            :items="detailItem"
            :search="search"
            class="elavation-1"
:sort-by="['code']"
        >
        </v-data-table>
        </div>
        <div v-if="isErr">
            <app-error
                v-bind:parentError="{
                data: this.errMsg,
                isErr: this.isErr,
                }"
                v-on:closeError="isErr = $event"
            />
        </div>
    </div>
</template>

<script>
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
    props: {
        parentObject: Object
    },

    components: {
        "app-error": ErrorDialog,
    },

    data() {
        return {
            publicPath: process.env.BASE_URL,
            search: "",
            rules: {
                // required: value => !!value || this.$t('reportsparam.required'),
                // percentage: value => !(value < 0 || value > 100) || this.$t('reportsparam.valueonetohundred')
            },

            detailItem: this.parentObject.detailItem,

            formData: {
                pmassessmentrecordid: this.parentObject.pmassessmentrecordid,
                updatedby: this.$store.getters.userId,
            },
            isEdit: this.parentObject.isEdit,
            isAdvanceEdit: this.parentObject.isAdvanceEdit,
            isErr: false,
            errMsg: ''
        }
    },

    methods: {
            //This 3 is method use to export CSV
        objectToCSV(data) {
            const csvRows = [];

            //get header
            const headers = Object.keys(data[0]);
            //const headers = this.titles
            csvRows.push(headers.join(","));

            //loop over the rows
            for (const row of data) {
                const values = headers.map((header) => {
                const escaped = ("" + row[header]).replace(/"/g, '\\"');
                return `"${escaped}"`;
                });
                csvRows.push(values.join(","));
            }
            return csvRows.join("\n");
        },
        download(data) {
            const blob = new Blob([decodeURIComponent('%ef%bb%bf'), data], { type: "text/csv;charset=utf-8;" });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.setAttribute("hidden", "");
            a.setAttribute("href", url);
            a.setAttribute("download", this.parentObject.pageTitle + ".csv");
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        },
        async getCSV() {
            let titles = this.parentObject.tabHeader;
            let item = this.detailItem;
            let data = [];
            let obj2 = {};

            titles.forEach((element1) => {
                let x = element1.text;
                obj2[x] = element1.value;
            });

            item.forEach((element1) => {
                let obj = {};
                titles.forEach((element2) => {
                if (element2.value != "action") {
                    let key = element2.text;
                    obj[key] = element1[element2.value];
                }
                });
                data.push(obj);
            });

            const csvData = this.objectToCSV(data);
            this.download(csvData);
        },
    },

    async mounted() {
        // try {
            
        // } catch (err) {
        //     this.isErr = true;
        //     this.errMsg = err.message || "An error occurred while loading data";
        //     console.error("❌ Error in mounted:", err);
        // }
    },

}
</script>